import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import Input from '../ui/Input';
import Button from '../ui/Button';
import AuthLayout from './AuthLayout';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';

const { FiMail, FiArrowLeft } = FiIcons;

const ForgotPassword = () => {
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const { resetPassword } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const email = formData.get('email');

        setLoading(true);
        try {
            const { error } = await resetPassword(email);
            if (error) throw error;
            setSubmitted(true);
            toast.success('Password reset link sent!');
        } catch (error) {
            toast.error(error.message || 'Failed to send reset link');
        } finally {
            setLoading(false);
        }
    };

    if (submitted) {
        return (
            <AuthLayout
                title="Check your email"
                subtitle="We've sent password reset instructions to your email."
            >
                <div className="text-center space-y-6">
                    <div className="w-16 h-16 bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400 rounded-full flex items-center justify-center mx-auto">
                        <span className="text-2xl">✉️</span>
                    </div>
                    <p className="text-gray-600 dark:text-gray-400">
                        Didn't receive the email? Check your spam folder or try again.
                    </p>
                    <Button variant="secondary" className="w-full" onClick={() => setSubmitted(false)}>
                        Try another email
                    </Button>
                    <Link to="/login" className="inline-flex items-center gap-2 text-sm font-semibold text-gray-600 dark:text-gray-400 hover:text-indigo-600 transition-colors">
                        <FiArrowLeft /> Back to login
                    </Link>
                </div>
            </AuthLayout>
        );
    }

    return (
        <AuthLayout
            title="Forgot password?"
            subtitle="No worries, we'll send you reset instructions."
        >
            <form onSubmit={handleSubmit} className="space-y-6">
                <Input
                    label="Email Address"
                    placeholder="name@company.com"
                    type="email"
                    name="email"
                    icon={FiMail}
                    required
                />
                <Button type="submit" className="w-full" isLoading={loading}>
                    Reset password
                </Button>
                <div className="text-center">
                    <Link to="/login" className="inline-flex items-center gap-2 text-sm font-semibold text-gray-600 dark:text-gray-400 hover:text-indigo-600 transition-colors">
                        <FiArrowLeft /> Back to login
                    </Link>
                </div>
            </form>
        </AuthLayout>
    );
};

export default ForgotPassword;